import {
  whatIfInnerSelector,
  whatIfOrDefaultSelector,
} from '../../WhatIfsSelector';

export const options = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.StrategyOptions || [];
};

export const strategySelected = (state, props) => (
  whatIfInnerSelector(state, props).DebtRepaymentStrategy
);
